import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isResendingSelector, alternativeEmailSelector, activatedSelector } from '../selectors/wizardSelectors';
import { resendVerificationCodeRequest } from '../actions/wizardActions';
import ResendActivationCodeForm from '../components/ResendActivationCodeForm/ResendActivationCodeForm'

const mapStateToProps = createStructuredSelector({
    isResending: isResendingSelector,
    disabled: activatedSelector,
    alternativeEmail: alternativeEmailSelector
});

const mapDispatchToProps = { resendVerificationCodeRequest };

export default connect(mapStateToProps, mapDispatchToProps)(ResendActivationCodeForm);
